import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteUploadedMedia: (
  fetchContext: FetchContext,
  uploadedMediaId: number,
  accessToken?: string) => Promise<void> = (fetchContext, uploadedMediaId, accessToken) => 
    fetch(`${fetchContext.baseUrl}/api/uploaded-media/${uploadedMediaId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete uploaded media'));
